import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { Image } from 'bricks';
import * as SharedZoneProductGoods from 'store/SharedZone/blocks/goods/selectors';

import styles from './styles.pcss';

const cx = classNames.bind({ ...styles });

function GoodsDayImage({ url, imageUrl, title, className, onClick }) {
  return (
    <a onClick={onClick} href={url} className={className}>
      <Image
        fallbackClassName={cx('fallback')}
        src={imageUrl}
        alt={title}
        className={cx('image')}
      />
    </a>
  );
}

GoodsDayImage.propTypes = {
  url: PropTypes.string,
  className: PropTypes.string,
  imageUrl: PropTypes.string,
  title: PropTypes.string,
  onClick: PropTypes.func,
};

const mapStateToProps = (state) => ({
  url: SharedZoneProductGoods.getUrl(state),
  imageUrl: SharedZoneProductGoods.getImageUrl(state),
  title: SharedZoneProductGoods.getTitle(state),
});

export default SharedZoneProductGoods.connect(mapStateToProps)(GoodsDayImage);
